import React, { useState, useEffect } from "react";
import { fetchAll } from "../utils/fetchResources";
import { useHistory, Prompt } from "react-router-dom";
import {
	Typography,
	FormControl,
  FormControlLabel,
  Switch,
	InputLabel,
	Select,
	MenuItem,
	Button,
	TextField,
	Grid,
	Card,
	CardContent,
	Hidden,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import SetFile from "../components/SetFile";

const useStyles = makeStyles((theme) => ({
	form: {
		width: "100%", // Fix IE 11 issue.
	},
	submit: {
		margin: theme.spacing(2, 0, 1),
	},
}));

export default function ThemesAdd(props) {
	const classes = useStyles();
	const [theme, setTheme] = useState({});
	const [sites, setSites] = useState([]);
	const [loading, setLoading] = useState(true);
	const [unsaved, setUnsaved] = useState(false);
	const [isRegion, setIsRegion] = useState(false);
	const { enqueueSnackbar } = useSnackbar();
	const history = useHistory();

	useEffect(() => {
		(async () => {
			await fetchAll("sites", setSites, "name");
			setLoading(false);
		})();
	}, []);

	const onChange = (e) => {
		setTheme({ ...theme, [e.target.name]: e.target.value });
		setUnsaved(true);
	};

  useEffect(()=>{
    setTheme({...theme, isRegion});
  },[isRegion]);

	const onSubmit = (e) => {
		e.preventDefault();
		fetch(`${process.env.REACT_APP_API_URL}/themes`, {
			method: "POST",
			credentials: "include",
			body: JSON.stringify(theme),
			headers: { "Content-Type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					setUnsaved(false);
					enqueueSnackbar("Theme added successfully!", { variant: "success" });
					history.push(`/${process.env.REACT_APP_ADMIN_URL}/themes`);
				} else {
					console.log(data);
					const errorArray = data.error.split(",");
					errorArray.forEach((error) => {
						enqueueSnackbar(`${error}`, { variant: "error" });
					});
				}
			});
	};

	if (loading) {
		return <div>Loading...</div>;
	}

	return (
		<>
			<Prompt
				when={unsaved}
				message="You have unsaved changes. Are you sure you want to leave?"
			/>
			<Typography component="h1" variant="h4">
				Add a Theme
			</Typography>
			<form className={classes.form} onSubmit={onSubmit}>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={12} md={9}>
						<TextField
							variant="outlined"
							margin="normal"
							fullWidth
							id="name"
							label="Theme Name"
							name="name"
							size="small"
							autoFocus
							required
							onChange={onChange}
						/>
						<FormControl
							fullWidth
							size="small"
							margin="normal"
							variant="outlined"
							className={classes.formControl}
							required
							name="site"
						>
							<InputLabel id="site-theme-label">Site</InputLabel>
							<Select
								inputProps={{ name: "site" }}
								value={theme.site}
								onChange={onChange}
								label="site"
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								{sites &&
									sites.map((site, index) => {
										return (
											<MenuItem key={index} value={site.id}>
												{site.name}
											</MenuItem>
										);
									})}
							</Select>
						</FormControl>
            <FormControlLabel
              control={
                <Switch
                  checked={isRegion}
                  onChange={()=>{setIsRegion(!isRegion)}}
                  name="isRegion"
                  color="primary"
                />
              }
              label="Is this theme a region?"
            />
						<Button
							type="submit"
							fullWidth
							variant="contained"
							color="primary"
							className={classes.submit}
						>
							Save
						</Button>
					</Grid>
					<Grid item xs={12} sm={12} md={3}>
						<Card>
							<CardContent>
								<Hidden smDown>
									<Button
										type="submit"
										onClick={onSubmit}
										fullWidth
										variant="contained"
										color="primary"
										className={classes.submit}
									>
										Save
									</Button>
								</Hidden>
								<SetFile
									fileTitle="Featured Image"
									resource={theme}
									setResource={setTheme}
									imageOnly={true}
									fileLabel="featuredImage"
									fileLabelFileName="featuredImageFile"
								/>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</form>
		</>
	);
}
